import * as React from 'react';
import { ThemeProvider, useTheme } from '@mui/material/styles';
// import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
// import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Bs4Tooltip from '../Bs4Components/Bs4Tooltip';
import Typography from '@mui/material/Typography';
// import useScrollTrigger from '@mui/material/useScrollTrigger';
// import Slide from '@mui/material/Slide';

import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4Kartoteka from '../Bs4Kartoteka';
import Bs4MainWindow, {TYPE_APPBAR, TYPE_INCOMING} from '../Bs4MainWindow';
import Bs4SearchEngine from './Bs4SearchEngine'

import { getFieldThemeObj } from '../Bs4Theme/Bs4Theme';
import { getBoxSx, getBoxStyle, useStateUxTemplate, SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';
import Bs4I18N from '../Bs4I18N';
import { HideOnScroll } from '../Bs4Components/HideOnScroll';
import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import Bs4HorizontalMenu from '../Bs4Menu/Bs4HorizontalMenu';

export default class Bs4AppBar {
  constructor() {
    if (Bs4AppBar.instance) {
      throw new Error("Singleton (Bs4AppBar) classes can't be instantiated more than once.")
    }
    Bs4AppBar.instance = this;
  }  
  
  topMessagesInfo = null;

  showTooltipIncomingItem = null;
  showTooltipIncoming = (showTooltipIncomingItem) => {}
  showTooltip = (id, showTooltip, closeTooltip) => {
    this.showTooltipIncomingItem = {
      id, 
      showTooltip, 
      closeTooltip,
    }
    if (this.showTooltipIncoming) this.showTooltipIncoming(this.showTooltipIncomingItem)    
  }

  getIncomingItem = (id) => {
    for(const item of this.topMessagesInfo?._Komunikat || []) {
      if (String(item.openPage) === String(id)) return item;
    }
  }

  isBs4ArtistMode = () => {
    const bs4Kartoteka = Bs4Kartoteka.get(Bs4Kartoteka.firstBs4KartotekaId);
    return bs4Kartoteka?.message?._Komunikat?.bs4ArtistMode;
  }
  

  isBs4ConstructorMode = () => {
    const bs4Kartoteka = Bs4Kartoteka.get(Bs4Kartoteka.firstBs4KartotekaId);
    return bs4Kartoteka?.message?._Komunikat?.bs4ConstructorMode;
  }

  bs4TopMsgsRefresh = () => {}

  IncomingItem = React.forwardRef((props, ref) => {
    const handleOnClickSub = (event) => {
      // console.log('...Incoming click tooltip', event)
      Bs4MainDispatch.commandParserAfter(Bs4Kartoteka.topBs4Kartoteka.bs4KartotekaId)
    }

    const handleOnClickMain = (openPage) => {
      // console.log('...Incoming click main', openPage)
      const details = {currFormId: '', targetObject: '', targetOption: openPage, topCallFor: openPage  };   
      Bs4MainDispatch.commandParser('Bs4OpenCard', details, Bs4Kartoteka.topBs4Kartoteka.bs4KartotekaId); 
    }  

    React.useEffect(() => {      
      if (String(props.item?.openPage) === String(props.showTooltip?.id)) {
        // console.log('...Bs4ShowTooltip...IncomingItem', props.item?.openPage, props.showTooltip?.id, props.showTooltip, ref);
        props.showTooltip.showTooltip(ref, () => {
          props.showTooltip.setShowTooltip(null);
        });
      }      
    }, [props.showTooltip, ref]);
    
    return (
      <Bs4Tooltip         
        leaveDelay={200}
        // open
        enterDelay={0}
        disableFocusListener
        title={<div dangerouslySetInnerHTML={{__html: props.item?.tooltip}} onClick={handleOnClickSub}/>} 
        arrow 
      >
        <IconButton ref={ref} onClick={() => {handleOnClickMain(props.item.openPage)}} sx={{transform: props.transform, paddingTop: '12px'}}>
          <Badge 
            invisible={!Boolean(props.item?.counter)} 
            badgeContent={props.item?.counter} 
            max={999999} 
            //overlap='circular'
            color='info' //success
            // sx={{ "& .MuiBadge-badge": {fontSize: boxSx.fontSize * 0.45}}}
            // sx={{ "& .MuiBadge-badge": {color: '#ff0000', backgroundColor: '#ffff00'}}}                  
          >
            <Box component='span' className={props.item?.icon} sx={{lineHeight: 'initial', fontSize: props.boxSx?.fontSize}} />
          </Badge>
        </IconButton>
      </Bs4Tooltip>
    )
  })

  Incoming = (props) => {
    const incomingThis = this;
    const theme = useTheme();
    const [topMessagesInfo, setTopMessagesInfo] = React.useState(null);
    const [showTooltip, setShowTooltip] = React.useState(null);
    
    const boxSx = React.useMemo(() => {
      const boxSx = {};      
      if (props.uxTemplate?.incoming?.spacing)  boxSx.spacing = props.uxTemplate.incoming.spacing;
      if (props.uxTemplate?.incoming?.fontSize) boxSx.fontSize = getBoxSx({fontSize: props.uxTemplate?.incoming?.fontSize}, theme).fontSize;
      // console.log('... Bs4AppBar ... Incooming', uxTemplate.incoming)
      return boxSx;
    }, [theme, props.uxTemplate]);

    const [transform, spacing] = React.useMemo(() => {
      let scale = props.uxTemplate?.incoming?.scale || 1;
      let spacing = boxSx.spacing || 2;        
      return [`scale(${scale})`, spacing];
    }, [boxSx])     

    React.useEffect(() => {      
      this.setTopMessagesInfo = (message) => {
        this.topMessagesInfo = message;
        setTopMessagesInfo(message);
      }
      
      this.showTooltipIncoming = (showTooltipIncomingItem) => {        
        setShowTooltip({
          ...showTooltipIncomingItem,
          setShowTooltip,
        });
      }

      if (this.showTooltipIncomingItem) this.showTooltipIncoming(this.showTooltipIncomingItem);
      
      let bs4TopMsgsRefreshTimeout = 0;
      let lastDateNow = null
      this.bs4TopMsgsRefresh = (dateNow, from) => {
        if (dateNow === lastDateNow) return;
        lastDateNow = dateNow;
        clearTimeout(bs4TopMsgsRefreshTimeout);
        bs4TopMsgsRefreshTimeout = setTimeout(() => {
          Bs4MainDispatch.commandParser('Bs4TopMsgs', {event: from}, Bs4Kartoteka.firstBs4KartotekaId);  
        }, 500);                
      }
    }, [setTopMessagesInfo, setShowTooltip])

    // console.log('... Incoming ... ', transform, boxSx)

    return (
      <Stack spacing={spacing} direction="row">
        {topMessagesInfo?._Komunikat?.map((item, index) => {
          item.ref = {current: null}
          return (
            <incomingThis.IncomingItem ref={item.ref} key={index} item={item} transform={transform} boxSx={boxSx} showTooltip={showTooltip}/>
          )
        })}
      </Stack>
    );
  }

  showObject = null;
  
  isEqualId = (id, item) => {    
    if (item.id && String(item.id) === String(id)) return true;
    return false
  }

  AvatarBs4View = (props) => {

    const handleClick = (event) => {
      console.log('%c %s ', 'color: yellow; background-color: darkred; font-size: 24px', `Build date ${Bs4Utils.toDateTime(Bs4MainDispatch.buildDate)}`);
      Bs4MainDispatch.commandParserAfter(Bs4Kartoteka.firstBs4KartotekaId);
      if (props.handleClose) props.handleClose();
    }

    const avatarbs4 = Bs4MainDispatch.updateUrlText(props.mainPageDetails?._Komunikat?.avatarbs4);
    return (
      <div dangerouslySetInnerHTML={{__html: avatarbs4}} onClick={handleClick}/>
    )
  }

  plusTopMenu = null;
  setPlusTopMenu = (menu) => {
    this.plusTopMenu = menu;
  }

  rightMenu = null;
  setRightMenu = (menu) => {
    this.rightMenu = menu;
  }

  StartIcon = (props) => {
    return (
      <Stack direction="row" sx={{width: 24, height:24, justifyContent: 'center', alignItems: "center",}}>    
        <i className="fa-solid fa-plus"/>
      </Stack>
    )
  }

  ViewComponent = (props) => {    
    const appBar = this;
    const smallScreen = React.useContext(SmallScreenContext);
    const refIconButton = React.useRef(null);
    const mainTheme = useTheme();    
    const menuItemsPlusTop = React.useMemo(() => {
      let menu = [];
      try {
        menu = JSON.parse(JSON.stringify(props.mainPageDetails?._Komunikat?.plustopmenu));        
        //menu = JSON.parse(JSON.stringify(props.mainPageDetails?._Komunikat?.righttopmenu));
      } catch(error) {
        menu = [];
      } 
      return menu;
    }, [props.mainPageDetails?._Komunikat?.righttopmenu])

    const menuItemsRight = React.useMemo(() => {
      let menu = [];
      try {
        menu = JSON.parse(JSON.stringify(props.mainPageDetails?._Komunikat?.righttopmenu));
      } catch(error) {
        menu = [];
      } 
      return menu;
    }, [props.mainPageDetails?._Komunikat?.righttopmenu])    
    
    const {dateTimeStamp} = useStateUxTemplate([TYPE_APPBAR, TYPE_INCOMING]);
    
    const uxTemplate = React.useMemo(() => {
      return Bs4MainWindow.instance?.bs4MainWindowUx?.uxTemplate.body?.AppBar;
    }, [mainTheme, dateTimeStamp]);

    const theme = React.useMemo(() => {
      const box = uxTemplate?.box;
      const theme = getFieldThemeObj(mainTheme, {
        color: box?.color || null, 
        backgroundColor: box?.backgroundColor || mainTheme.Bs4.backgroundColor || null
      })      
      return theme;
    }, [mainTheme, uxTemplate, dateTimeStamp])        
    
    const handleZalogowanyClick = (event) => {      
      Bs4I18N.listnoPhrase();
    }    
            
    const refSpeedTest = React.useRef({
      shallowEqualValues: null,
      shallowEqualProps: null,
    });
      
    const logosrc = Boolean(props.mainPageDetails?._Komunikat?.logosrc) 
      ? Bs4MainDispatch.updateUrlText(Bs4MainDispatch.getUrlPath(props.mainPageDetails?._Komunikat?.logosrc)) 
      : null;
    const [boxSx1, boxSx2] = React.useMemo(() => {
      const boxSx1 = getBoxSx(uxTemplate?.box, theme);
      const boxSx2 = {};
      if (boxSx1.height) boxSx2.height = boxSx1.height;
      delete boxSx1.height;
      return [boxSx1, boxSx2];
    }, [theme, uxTemplate?.box])
  
    React.useEffect(() => {
      const visibilitychange = (event) => {
        if (!document.hidden) {
          this.bs4TopMsgsRefresh(Date.now(), 'visibilitychange');
        }
      }

      const storage = (event) => {
        if (event.key === Bs4MainDispatch.BS4_TOP_MSGS_REFRESH) {
          const dateNow = parseInt(window.localStorage.getItem(Bs4MainDispatch.BS4_TOP_MSGS_REFRESH));
          this.bs4TopMsgsRefresh(dateNow, Bs4MainDispatch.BS4_TOP_MSGS_REFRESH);
        }  
      }

      document.addEventListener('visibilitychange', visibilitychange);
      window.addEventListener('storage', storage);

      let intervalCall = null;
      if (props.mainPageDetails?._Komunikat?.msginterval) {
        this.bs4TopMsgsRefresh(Date.now(), 'start');
        intervalCall = setInterval(() => {
          this.bs4TopMsgsRefresh(Date.now(), 'msginterval');
        }, parseInt(props.mainPageDetails?._Komunikat?.msginterval));                
      }    

      return () => {
        document.removeEventListener('visibilitychange', visibilitychange);
        window.removeEventListener('storage', storage);
        clearInterval(intervalCall);
      };
    }, [props.mainPageDetails]);
    
    const sxLogo = getBoxStyle( uxTemplate?.logo, theme)

    const handleMenuClick = React.useCallback((item) => {
      // console.log('... Bs4AppBar...Menu...new  ', item)
      if (Bs4MainDispatch.isCommandParserWaitForServer()) return;
      const bs4Kartoteka = Bs4Kartoteka.getLast();
      Bs4MainDispatch.commandParser('Bs4MenuClick', {optionId: item?.bs4Id}, bs4Kartoteka.bs4KartotekaId);      
    }, []);

    Bs4MainDispatch.speedRun((tag) => {
      const newObj = {  
      };
      console.log(Bs4MainDispatch.speedNextTime(tag), Bs4Utils.shallowEqual(newObj, refSpeedTest.current.shallowEqualValues, Bs4MainDispatch.speedPrefix+tag+' EqualValues'), Bs4Utils.shallowEqual(props, refSpeedTest.current.shallowEqualProps, Bs4MainDispatch.speedPrefix+tag+' EqualProps'));
      refSpeedTest.current.shallowEqualValues = newObj;
      refSpeedTest.current.shallowEqualProps = props;
    }, '..AppBAR..');

    if (!props.mainPageDetails) return null;

    return (
      <ThemeProvider theme={theme}>
        <HideOnScroll debug='AppBar' type='AppBar'>
        <Stack 
          direction="row" 
          justifyContent="flex-start" 
          alignItems="center"
          //flexWrap={'wrap'}
          sx={{...boxSx1}}
          overflow='auto'
          onDoubleClick={(event) => {
            console.log('%c %s ', 'color: yellow; background-color: darkred; font-size: 24px', `Build date ${Bs4Utils.toDateTime(Bs4MainDispatch.buildDate)}`);
            // let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            // let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
            // console.log('%c %s ', 'color: yellow; background-color: darkred; font-size: 24px', `Width: ${vw}, Height: ${vh}`);      
          }}
        >             
          <Stack 
            direction="row" 
            flex={1}
            justifyContent="space-between"
            alignItems="center"
            //alignItems="flex-end"
            spacing={smallScreen ? 0.2 : 2}          
            sx={{...boxSx2}}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="center">  
              {props.MenuIconButton}
              {(!logosrc || smallScreen) ? null :
                <a href="" style={{height:'100%', overflow: 'hidden'}}>
                  <img style={{width:'100%', height:'100%', ...sxLogo}} src={logosrc} border="0"/>
                </a>
              }
            </Stack>                        
            <appBar.Incoming uxTemplate={uxTemplate}/>
            <span/>
          </Stack>
          <Stack 
            direction="row"               
            sx={{              
              // justifyContent: "space-evenly",
              justifyContent: "space-between",
              alignItems: "center",
              //alignItems: "flex-end",
              paddingX: 1,
            }}            
            spacing={smallScreen ? 1 : 2}
            //sx={{...boxSx2}}    
          >    
            <Bs4HorizontalMenu               
              bs4Menu={menuItemsPlusTop} 
              onMenuClick={handleMenuClick}       
              setMenu={appBar.setPlusTopMenu}              
              startIcon={appBar.StartIcon}
              IconButton={true}
              targetOption={300}
            />
            <Bs4SearchEngine searcc={props.mainPageDetails?._Komunikat?.searcc} mainTheme={mainTheme}/>
            
            {smallScreen ? null :
              <Typography variant="body2" gutterBottom onClick={handleZalogowanyClick}>
                {props.mainPageDetails?._Komunikat?.zalogowany}
              </Typography>
            }
            {smallScreen ? null : <appBar.AvatarBs4View {...props}/>}
            <Bs4HorizontalMenu               
              bs4Menu={menuItemsRight} 
              onMenuClick={handleMenuClick} 
              setMenu={appBar.setRightMenu}              
              IconButton={true}
              targetOption={300}
            />
          </Stack>
        </Stack>
        </HideOnScroll>
      </ThemeProvider>
    );
  }
}